module.exports = __webpack_public_path__ + "img/circle-blue.d78d8a64.png";